import { useMemo } from 'react';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { useLoginState } from 'src/app/shared/hooks/session';

import { useIsMembershipEligible } from '../useIsMembershipEligible';

export function useSaveBraintreePaymentTemporarily(): boolean {
	const {
		data: {
			user: { hasPaymentMethod, savedPaymentMethods },
		},
	} = usePromotePageData();

	const isEligibleForMembership = useIsMembershipEligible();

	const loginState = useLoginState();

	const saveBraintreePaymentTemporarily = useMemo(() => {
		if (!isEligibleForMembership) return false;
		if (loginState === 'IDENTIFIED' && hasPaymentMethod) return false;
		if (loginState === 'AUTHENTICATED' && savedPaymentMethods?.find((method) => method.type === 'paypal')) return false;
		return true;
	}, [isEligibleForMembership, loginState, hasPaymentMethod, savedPaymentMethods]);

	return !!saveBraintreePaymentTemporarily;
}
